import { createSelector } from 'reselect';
import get from 'lodash/get';
import { initialState } from './reducer';
import { createSelectFieldOptions } from '../../utils/common';

const selectFestivalsDomain = state => state.Festivals || initialState;

const selectFestivalsList = () => createSelector(selectFestivalsDomain, subState => get(subState, 'festivals'));

const selectLoading = () => createSelector(selectFestivalsList(), subState => get(subState, 'loading'));

const selectYearsList = () => createSelector(selectFestivalsDomain, subState => get(subState, 'years'));
const selectYears = () => createSelector(selectYearsList(), list => get(list, 'data'));
const selectYearsOptions = () =>
  createSelector(selectYears(), data => createSelectFieldOptions(data, 'id', 'name', {}, true));

const selectYearsLoading = () => createSelector(selectYearsList(), subState => get(subState, 'loading'));

const selectCountriesList = () => createSelector(selectFestivalsDomain, subState => get(subState, 'countries'));
const selectCountries = () => createSelector(selectCountriesList(), list => get(list, 'data'));
const selectCountriesOptions = () =>
  createSelector(selectCountries(), countries => createSelectFieldOptions(countries, 'id', 'name', {}, true));

const selectSearchFestivalsList = () =>
  createSelector(selectFestivalsDomain, subState => get(subState, 'searchFestivalsList'));
const selectSearchFestivals = () => createSelector(selectSearchFestivalsList(), list => get(list, 'data'));
const selectSearchFestivalsOptions = () =>
  createSelector(selectSearchFestivals(), data => createSelectFieldOptions(data, 'id', 'name', {}, true));
const selectSearchFestivalsOptionsLoading = () =>
  createSelector(selectSearchFestivalsList(), data => get(data, 'loading', false));

const selectFestivalsProductions = () =>
  createSelector(selectFestivalsDomain, subState => get(subState, 'festivalProductions'));

export {
  selectFestivalsDomain,
  selectFestivalsList,
  selectLoading,
  selectYearsOptions,
  selectCountriesOptions,
  selectSearchFestivalsOptions,
  selectSearchFestivalsOptionsLoading,
  selectSearchFestivalsList,
  selectFestivalsProductions,
  selectYearsLoading,
};
